import { Box, Paper, Stack, Typography } from "@mui/material"
import { t } from "i18next"
import React from "react"
import { isArrayNullOrEmpty } from "../../helper/helper"
import { OrganisationModel } from "../../models/organisation/OrganisationModelV2"
import { colorGrey } from "../../rsc/colors/colors"
import { ButtonCreateQualityPrices } from "./ButtonCreateQualityPrices"
import { ButtonDeleteQBP } from "./ButtonDeleteQBP"
import { QualityLevel } from "../../models/organisation/QualityLevel"
import "../../styles/pem-card.css"


type Props = {
  style?: React.CSSProperties
  org?: OrganisationModel
}

export function CompanyQBP({ style, org }: Props) {

  const qualityLevels: QualityLevel[] = org?.economics?.qbp ?? []

  return (
    <div className="flat-box-shadow padding15" style={style}>
      <div className="pem-header left-aligned">
        <span className="greyColor bold pem-title">
          {t('quality_level')}
        </span>
      </div>

      {qualityLevels.length === 0 ? (
        <div className="pem-empty-state italic">
          {t('no_quality_price_created')}
        </div>
      ) : (
        <div className="pem-content-flex with-margin">
          {qualityLevels.map((item, index) => (
            <div key={index} className="flat-box-shadow padding15 gap5centered">
              <span style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#333'
              }}>
                {item.name}
              </span>
            </div>
          ))}
        </div>
      )}

      <div className="pem-actions centered">
        {!isArrayNullOrEmpty(org?.economics?.qbp) && (
          <ButtonDeleteQBP org={org.organisation} />
        )}
        {org?.organisation && (
          <ButtonCreateQualityPrices org={org.organisation} />
        )}
      </div>
    </div>
  )
}